<template>
    <div class="course-details">
        <div class="course-details-header-pc">
            <div class="first-section">
                <div class="back-container">
                    <i @click="handleRoute('/tutorial')" class="el-icon-back icon"></i>
                    <i @click="handleRoute('/user/myCourse')" class="el-icon-setting icon"></i>
                </div>
                <div class="previous-container">
                    <i class="el-icon-arrow-left icon previous-icon"></i>
                    <div class="previous-title">Previous Build</div>
                </div>
            </div>
            <div class="second-section">
                <div class="complete">Complete and continue</div>
                <i class="el-icon-arrow-right icon next-icon"></i>
            </div>
        </div>
        <div class="course-details-header-mobile">
            <div class="first-section">
                <img @click="handleRoute('/tutorial')"
                    class="back-icon"
                    src="../assets/img/mobile/back-icon.png"
                    alt=""
                />
                <img @click="handleRoute('/index')"
                    class="logo-icon"
                    src="../assets/img/user-interface-logo.png"
                    alt=""
                />
                <img @click="handleRoute('/user/myCourse')"
                    class="setting-icon"
                    src="../assets/img/mobile/setting-icon.png"
                    alt=""
                />
            </div>
            <div class="second-section">
                <img
                    @click="toggleModal()"
                    class="menu-icon"
                    src="../assets/img/mobile/user-interface-menu-icon.png"
                    alt=""
                />
                <img
                    class="prev-icon"
                    src="../assets/img/mobile/prev-icon.jpg"
                    alt=""
                />
                <img
                    class="next-icon"
                    src="../assets/img/mobile/next-icon.jpg"
                    alt=""
                />
            </div>
        </div>
        <div class="course-details-content">
            <el-col class="course-details-side-bar" :span="12">
                <div class="course-details-ata-logo">
                    <img @click="handleRoute('/index')" src="../assets/img/user-interface-logo.png" alt="" />
                </div>
                <div class="course-details-title">
                    {{ course.courseTitle }}
                </div>
                <el-menu default-active="2" class="el-menu-vertical-demo">
                    <el-submenu
                        v-for="(lesson, index) in course.lessons"
                        :key="lesson.key"
                        :index="index"
                    >
                        <template #title>
                            <span>{{ lesson.title }}</span>
                        </template>

                        <el-menu-item
                            v-for="(child, cIndex) in lesson.child"
                            :key="child.key"
                            :index="`${index}-${cIndex}`"
                        >
                            <el-radio
                                v-model="selectedItem"
                                :label="child.key"
                                >
                                <img class="radio-icon" :src="child.icon">
                                <p>{{ child.title }} </p>
                            </el-radio>
                        </el-menu-item>
                    </el-submenu>
                </el-menu>
            </el-col>

            <div class="course-details-information">
                <div class="course-details-title">
                    {{ showContent.content }}
                </div>
                <div class="course-details-subtitle">
                    This Course is presented and designed by:
                </div>
                <div class="teacher-container">
                    <img src="../assets/img/teacher-pic001.jpg" alt="" />
                    <div class="teacher-infomation">
                        <div class="teacher-name">Ms. Dengdeng</div>
                        <div class="teacher-title">
                            - Senior Instructor at Everyday Chinese -
                        </div>
                        <div class="teacher-detail">
                            Dengdeng is a senior instructor at Everyday Chinese
                            with over 6 years of teaching experience in China
                            and abroad. She approaches every Chinese lesson with
                            enthusiasm. Dengdeng majored in teaching Chinese as
                            a second language in university and got an
                            international Chinese teacher certificate. After
                            graduation, she worked as a Chinese teacher in a
                            college of Thailand for 3 years. Then she joined the
                            Everyday Chinese team and has gotten thousands of
                            fans all over the world since we posted her first
                            Mandarin lesson on our YouTube Channel about 2 years
                            ago. She is always passionate about helping people
                            explore Chinese language and culture.
                        </div>
                    </div>
                </div>
                <div class="teacher-container">
                    <img src="../assets/img/teacher-pic002.jpg" alt="" />
                    <div class="teacher-infomation">
                        <div class="teacher-name">Ms. Joyce</div>
                        <div class="teacher-title">
                            - Senior Instructor at Everyday Chinese -
                        </div>
                        <div class="teacher-detail">
                            Hello! I’m Joyce. I’ve been teaching Chinese for 9
                            years. My students are from different parts of the
                            world with diverse backgrounds and ages. Among them,
                            the youngest is 6 and the oldest are in their
                            seventies. My strength is to teach from the
                            learner’s perspective and cater to their needs with
                            the easiest to understand language. My goal is to
                            make your every class with me a fruitful one!
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="modal" class="sidebar-modal">
            <el-menu default-active="2" class="el-menu-vertical-demo">
                <el-submenu
                    v-for="(lesson, index) in course.lessons"
                    :key="lesson.key"
                    :index="index"
                >
                    <template #title>
                        <span>{{ lesson.title }}</span>
                    </template>

                    <el-menu-item
                        v-for="(child, cIndex) in lesson.child"
                        :key="child.key"
                        :index="`${index}-${cIndex}`"
                    >
                        <el-radio v-model="selectedItem" :label="child.key">
                            <span><img src="../assets/img/mobile/courses-icon-file.png"></span>
                            {{child.title}}
                        </el-radio>
                    </el-menu-item>
                </el-submenu>
            </el-menu>
        </div>
    </div>
</template>
<script>
export default {
    name: "Course",
    data() {
        return {
            data: {},
            modal: false,
            amount: "",
            selectedItem: "",
            showContent: "",
            course: {},
        };
    },
    mounted() {
        this.init();
        this.getCourseDetail();
    },
    watch: {
        selectedItem: function (val) {
            let keys = val.split("-");
            let parentIdx = keys[0] - 1;
            let childIdx = keys[1] - 1;
            this.showContent = this.course.lessons[parentIdx].child[childIdx];
            this.modal = false;
        },
    },
    methods: {
        init() {},
        toggleModal() {
            this.modal = !this.modal;
        },
        async getCourseDetail() {
            this.$api.getJson("course_details").then((response) => {
                if (response.status == 200) {
                    if (response.data != null) {
                        this.course = response.data;
                    }
                }
            });
        },
        handleRoute(link){
            this.$router.push({path:link});
        }
    },
};
</script>
<style lang='scss' type='text/css'>
@import "../styles/pc/Course.scss";
@import "../styles/mobile/Course.scss";
</style>
